/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCreateRequestItemsSchema } from "./banquetCreateRequestItemsSchema.ts";

export const banquetCreateRequestSchema = z
	.object({
		table_id: z.uuid(),
		start_time: z.iso.datetime(),
		duration_minutes: z.int().min(30).max(1440).optional(),
		guests_count: z.int().min(1).max(100),
		comment: z.string().max(250).optional(),
		customer_name: z.string().min(1).max(60).optional(),
		phone: z.string().max(20).optional().describe("Контактный телефон брони; не передан — берётся из профиля гостя"),
		country_code: z.string().min(1).max(4).optional().default("+7"),
		items: z.array(banquetCreateRequestItemsSchema).optional(),
		combos: z.array(banquetCreateRequestItemsSchema).optional(),
	})
	.describe("Предметная валидация выполняется MobileOrderCreateSerializer\nвнутри BanquetOrderService, а значит формат корзины полностью идентичен заказу.");
